import { ProfileStatusScreenComponent } from './profile-status-screen/profile-status-screen.component';
import { ProfilerProgressStepComponent } from './profiler-progress-step/profiler-progress-step.component';
import { ProfilerProgressComponent } from './profiler-progress/profiler-progress.component';

export const components = [
  ProfilerProgressComponent,
  ProfilerProgressStepComponent,
  ProfileStatusScreenComponent
];
